import e from "react";
import { getIconColor as r } from "./iconfont.es5470.js";
import v from "./iconfont.es5471.js";
const d = {
  display: "block"
}, m = ({ size: a = 16, useVw: t, useRem: l, color: o, withColor: c, removeClassName: n, disableSSR: p, style: i, ...x }) => {
  const h = i ? { ...d, ...i } : d;
  return /* @__PURE__ */ e.createElement(v, { disableSSR: p }, /* @__PURE__ */ e.createElement("svg", { "data-icon-id": "24px-fulizhongxin", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 24 24", width: t ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (l ? "rem" : "px"), height: t ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (l ? "rem" : "px"), className: n ? "" : "iconpark-icon", style: h, fill: "none", ...x }, /* @__PURE__ */ e.createElement(
    "g",
    {
      className: n ? "" : "24px-ç¦å©ä¸­å¿"
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        clipRule: "evenodd",
        className: n ? "" : "normal",
        d: "M8.908 1.938a.8.8 0 1 0-1.126 1.137l2.067 2.046H4.083A2.383 2.383 0 0 0 1.7 7.505v1.218c0 1.252.965 2.278 2.192 2.375v7.977a2.992 2.992 0 0 0 2.993 2.992h3.654a2.261 2.261 0 0 0 2.261-2.261V14.54a.8.8 0 0 0-1.6 0v5.266a.662.662 0 0 1-.661.661H6.885a1.392 1.392 0 0 1-1.393-1.392v-7.97h13.016v7.97c0 .769-.623 1.392-1.392 1.392h-1.827a.8.8 0 1 0 0 1.6h1.827a2.992 2.992 0 0 0 2.992-2.992v-7.977A2.383 2.383 0 0 0 22.3 8.723V7.505a2.383 2.383 0 0 0-2.383-2.384h-5.769l2.067-2.046a.8.8 0 0 0-1.126-1.137L12 4.998l-3.091-3.06ZM20.7 8.723a.783.783 0 0 1-.78.783H4.08a.783.783 0 0 1-.78-.783V7.505c0-.433.35-.784.783-.784h15.834c.432 0 .783.351.783.784v1.218Z",
        fillRule: "evenodd",
        fill: c ? r(o, 0, "#262933") : "#262933",
        datafollowfill: c ? r(o, 0, "#262933") : "#262933"
      }
    )
  )));
}, u = m;
export {
  u as default
};
